import { actionTypes, subscriptionStatus } from './constants';
import { apiCallStatus } from 'helpers/constants';

const initialState = {
    activeTab: subscriptionStatus.ACTIVE,
    subscriptionArr: {
        data: {
            assetSubscriptionsInfos: null,
        },
        error: null,
        loadingStatus: apiCallStatus.LOADING
    }
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_ACTIVE_TAB: {
            return {
                ...state,
                activeTab: action.activeTab
            };
        }
        case actionTypes.ACTIVE_SUB_DATA: {
            return {
                ...state,
                subscriptionArr: {
                    ...state.subscriptionArr,
                    data: action?.data,
                    error: action?.error,
                    loadingStatus: action?.loadingStatus
                }
            };
        }
        case actionTypes.CLEAR_STORE: {
            return {
                ...initialState,
            };
        }
        default:
            return state;
    }
};
